import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
 
import {appApiResources} from '../../../configuration/app.constants';

@Injectable({
  providedIn: 'root'
})
export class SearchContactCategoryService {

  constructor(private http: HttpClient) {}

  async getContactCategoryList() {
    try {
      // const httpOptions = {
      //   headers: new HttpHeaders({
      //     "Content-Type": "application/json",
      //     Authorization: `jwt ${idToken}`
      //   })
      // }; 
      let response = await this.http
        .get(`${appApiResources.getContactCategory}`)
        .toPromise();
      return response;
    } catch (error) { 
      return error;
    }
  }
}